import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import {
  loadLegalDocumentsCurrent,
  loadLegalDocumentsCurrentSuccess,
  loadLegalDocumentsCurrentFailure
} from '../actions/legal-documents.actions';
import { ILegalDocumentsResponse } from '../models/legal-documents.model';
import * as actions from '../actions';

export const currentLegalDocumentsFeatureKey = 'currentLegalDocuments';

export interface CurrentLegalDocumentsState {
  loadLegalDocumentsCurrent: any;
  loadLegalDocumentsCurrentSuccess: ILegalDocumentsResponse[];
  loadLegalDocumentsCurrentFailure: IGenericError<ErrorResponse>;
}

export const initialState: CurrentLegalDocumentsState = {
  loadLegalDocumentsCurrent: undefined,
  loadLegalDocumentsCurrentSuccess: undefined,
  loadLegalDocumentsCurrentFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadLegalDocumentsCurrent, (state, action) => ({
    ...state,
    loadLegalDocumentsCurrent: action.request
  })),
  on(actions.loadLegalDocumentsCurrentSuccess, (state, action) => ({
    ...state,
    loadLegalDocumentsCurrentSuccess: action.response
  })),
  on(actions.loadLegalDocumentsCurrentFailure, (state, action) => ({
    ...state,
    loadLegalDocumentsCurrentFailure: action.error
  }))
);

export const getCurrentLegalDocumentsRequest = (state: CurrentLegalDocumentsState) => state.loadLegalDocumentsCurrent;
export const getCurrentLegalDocumentsResponse = (state: CurrentLegalDocumentsState) => {
  return state.loadLegalDocumentsCurrentSuccess;
};
export const getCurrentLegalDocumentsFailure = (state: CurrentLegalDocumentsState) => state.loadLegalDocumentsCurrentFailure;
